<template>
  <div class="layout-container">
    <!-- <Sidebar @on-change="sidebarChange"></Sidebar> -->
    <div class="main-container">
      <HeaderEn v-if="i18nStore.locale === ELocale.en" />
      <Header v-else />
      <main class="main">
        <div class="error">
          <!-- error.msg 来自: util/common.ts-handleNodeServerError -->
          <div
            class="error-tip"
            v-if="statusCode == 404">
            <div>
              页面不存在
              <span
                class="more"
                @click="isShowMsg2 = !isShowMsg2">
                更多>>
              </span>
            </div>
            <div v-show="isShowMsg2">{{ errorMessage }}</div>
          </div>
          <div v-else-if="errorData && errorData.islimit">
            <div class="view_tip">
              <div class="card">
                <h1>今日浏览次数已达上限</h1>
                <p>{{ errorMessage }}</p>
              </div>
            </div>
          </div>
          <div
            class="error-tip"
            v-else>
            {{ $t('error.pageError') }}
            <span
              class="more"
              @click="isShowMsg = true">
              {{ $t('common.more') }}>>
            </span>
          </div>
          <div
            class="error-msg"
            v-if="isShowMsg">
            {{ errorMessage }}
          </div>
          <div
            v-if="isShowMsg"
            class="error-msg"
            style="font-size: 14px; text-align: left"
            v-html="error.stack" />
          <div
            class="button_box row-flex jsb ac"
            style="gap: 50px">
            <!-- <nuxt-link to="/" title="展会网" prefetch-on="interaction">{{ $t('menu.home') }}</nuxt-link> -->
            <a
              style="cursor: pointer"
              @click="handleHome">
              {{ $t('menu.home') }}
            </a>

            <a
              style="cursor: pointer"
              v-if="statusCode != 404"
              @click="handleRefresh">
              {{ $t('error.retry') }}
            </a>
          </div>
        </div>
      </main>
      <Footer2 />
    </div>
  </div>
</template>
<script lang="ts" setup>
  import { timestampToDateTime } from '~/utils/common'
  import { ELocale } from '~~/types/enums'

  const HeaderEn = defineAsyncComponent(() => import('~/componentsEn/HeaderEn.vue'))
  const Header = defineAsyncComponent(() => import('~/components/Header/index.vue'))
  const Footer2 = defineAsyncComponent(() => import('~/components/Footer2/index.vue'))

  const router = useRouter()
  const i18nStore = useI18nStore()
  const runtimeConfig = useRuntimeConfig()
  let lang = runtimeConfig.public.lang.toUpperCase()
  i18nStore.setLang(lang)
  // const lang = i18nStore.locale

  useLang(lang) // 设置语言
  // console.log('26--', lang)
  // useLang(lang) // 设置语言
  // useLang('cn') // 设置语言
  // useLang('en')
  // console.log('26--', runtimeConfig)

  const props = defineProps({
    error: {
      type: Object,
      default: () => {}
    }
  })

  //
  if (props.error.statusCode !== 404) {
    console.error('服务器错误-error--35', {
      error: props.error,
      time: timestampToDateTime(Date.now())
    })
  }

  let errorMessage = ref('')
  let isShowMsg = ref(false)
  let isShowMsg2 = ref(false)
  let statusCode = ref(null)
  let errorData = ref(null)

  // 解析错误信息
  try {
    if (props.error.statusCode !== 404) {
      console.log('error.vue-391', props.error.statusCode, props.error.message, props.error)
      errorData.value = props.error.data
    }
    statusCode.value = props.error.statusCode
    errorMessage.value = props.error.message || props.error.statusMessage
    if (props.error?.hasOwnProperty('message')) {
      let messageRes = JSON.parse(props.error.message)
      console.log('error.vue-41', props.error.message)
      errorMessage.value = messageRes.errorMsg
      // console.log('error.vue-40', props.error.message)
    }
    console.log(props.error, 126)
  } catch (e) {
    errorMessage.value = props.error.message
  }

  // console.dir(props.error)
  const handleHome = () => {
    // router.push('/')
    location.href = '/'
  }
  const handleRefresh = () => {
    // location.reload()

    // 给请求的资源 URL 添加一个时间戳或随机参数，使浏览器认为这是一个新请求
    // location.href = location.pathname + '?t=' + new Date().getTime()

    location.reload(true) // 强制从服务器重新加载，忽略缓存（部分浏览器支持）

    // 检查当前浏览器是否支持 Service Worker
    if ('serviceWorker' in navigator) {
      // 返回一个 Promise，当 Service Worker 已经注册并且处于激活状态时 resolve
      navigator.serviceWorker.ready.then(registration => {
        // 注销当前注册的 Service Worker
        registration.unregister().then(() => {
          console.log('Service Worker has been unregistered.') // 在控制台输出提示信息，表示 Service Worker 已被注销
          location.reload() // 重新加载页面以应用新的 Service Worker（如果有的话）
        })
      })
    }
  }
</script>
<style lang="less" scoped>
  .main {
    min-height: 630px;
  }

  .error {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 128px 0;

    &-msg {
      font-size: 32px;
      font-weight: bold;
      margin-bottom: 64px;
    }

    a {
      color: @app-color;
      text-decoration: underline;
      font-size: 28px;
    }
  }

  .error-msg {
    width: 1190px;
    text-align: left;
  }

  .error-tip {
    width: 100%;
    text-align: center;
    font-size: 32px;
    font-weight: 700;
    margin-bottom: 40px;

    .more {
      font-size: 24px;
      display: inline-block;
      margin-left: 15px;
      font-weight: 400;
      cursor: pointer;
    }
  }
  .view_tip {
    width: 1200px;
    min-height: 300px;
    color: #ffffff;
    position: relative;
    margin: 0 auto;
    .card {
      margin: 0 auto;
      background: white;
      width: 100%;
      max-width: 500px;
      padding: 40px;
      text-align: center;
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
      border-radius: 8px;
      position: relative;
      z-index: 1;
    }
    h1 {
      font-size: 24px;
      color: #333;
      margin-bottom: 16px;
    }
    p {
      font-size: 16px;
      color: #555;
      line-height: 1.5;
      margin-bottom: 24px;
    }
    .btn {
      background-color: #e50113;
      color: white;
      border: none;
      padding: 12px 24px;
      font-size: 16px;
      border-radius: 4px;
      cursor: pointer;
      transition: all 0.3s ease;
    }
    .btn:hover {
      background-color: #c70110;
    }
  }
</style>
